/* reformly-005.js
 *
 * Board PDP (005/006/007). Standalone fork of reformly-july4-hero.js — it binds
 * only to `.r5`, which no other template renders, so the six live Plus pages
 * keep running the original file untouched.
 */
(function () {
  var section = document.querySelector('.r5');
  if (!section) return;

  var pageTemplate = section.getAttribute('data-r5-template') || '';

  /* ---------------------------------------------------------------------
     PostHog — same project, one prefix + pageset per template so 005/006/007
     stay separable in reports (mirrors PAGESETS in reformly-july4-hero.js).
     --------------------------------------------------------------------- */
  var PAGESETS = {
    'reformly-30-day-plan-005': { set: '30-day-plan-005', prefix: 'r30x5_' },
    'reformly-30-day-plan-006': { set: '30-day-plan-006', prefix: 'r30x6_' },
    'reformly-30-day-plan-007': { set: '30-day-plan-007', prefix: 'r30x7_' },
    'app-membership-002': { set: 'app-membership-002', prefix: 'am2_' }
  };
  var pageset = PAGESETS[pageTemplate] || null;
  if (pageset && window.posthog && window.posthog.register) {
    window.posthog.register({ reformly_pageset: pageset.set });
  }
  function ph(event, props) {
    if (!window.posthog) return;
    var p = props || {};
    p.page_template = pageTemplate;
    window.posthog.capture((pageset ? pageset.prefix : '') + event, p);
  }
  ph('reformly_plus_page_view', { url: window.location.href, referrer: document.referrer });

  /* Scroll depth — 25/50/75/100, once each per pageview. Mirrors the tracker in
     reformly-july4-hero.js so 005 and the rj4 templates report identically. */
  (function () {
    var pageStart = Date.now();
    var fired = {};
    function scrollPct() {
      var top = window.scrollY || document.documentElement.scrollTop;
      var doc = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var win = window.innerHeight;
      if (doc <= win) return 100;
      return Math.round((top / (doc - win)) * 100);
    }
    window.addEventListener('scroll', function () {
      var pct = scrollPct();
      [25, 50, 75, 100].forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          ph('reformly_plus_scroll_depth', {
            depth: t,
            seconds_on_page: Math.round((Date.now() - pageStart) / 1000)
          });
        }
      });
    }, { passive: true });
  })();

  /* Gallery reach. Fires once per distinct slide per pageview, not per
     slideChange — swiping back and forth would otherwise inflate the count and
     make "images viewed per session" meaningless. Shared by both Swiper init
     paths below (the prebuilt markup and the JS-rendered one). */
  var galleryViewed = {};
  function trackGallerySlide(index) {
    if (index === undefined || index === null || galleryViewed[index]) return;
    galleryViewed[index] = true;
    ph('reformly_plus_gallery_view', {
      index: index,
      images_viewed: Object.keys(galleryViewed).length
    });
  }

  /* Quiz hand-off email.
     The funnel redirects here as ?email=…, and this page checks out directly, so
     the address is forwarded to Shopify as checkout[email] and the field arrives
     prefilled. Same mechanism and same sessionStorage key as
     reformly-plus-cart.js uses for reformly-30-day-plan-onboarding, so a visitor
     who crosses between the two keeps one stored address. */
  try {
    var _qsEmail = new URLSearchParams(location.search).get('email');
    if (_qsEmail && _qsEmail.indexOf('@') > 0) sessionStorage.setItem('ryp_email', _qsEmail);
  } catch (e) { /* private mode / storage disabled — checkout just asks for it */ }

  function checkoutEmailParam() {
    try {
      var em = sessionStorage.getItem('ryp_email');
      return em ? '?checkout%5Bemail%5D=' + encodeURIComponent(em) : '';
    } catch (e) { return ''; }
  }

  function $(sel, root) { return (root || section).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || section).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------------
     Announcement rotator
     --------------------------------------------------------------------- */
  (function () {
    var bar = $('[data-r5-announce]');
    if (!bar) return;
    var json = $('[data-r5-ann-list]', bar);
    var slots = $$('[data-r5-ann-slot]', bar);
    if (!json || !slots.length) return;
    var msgs;
    try { msgs = JSON.parse(json.textContent); } catch (e) { return; }
    if (!msgs || msgs.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-r5-interval'), 10) || 3600;
    var i = 0;
    setInterval(function () {
      bar.classList.add('is-fading');
      setTimeout(function () {
        i = (i + 1) % msgs.length;
        slots.forEach(function (el) { el.textContent = msgs[i]; });
        bar.classList.remove('is-fading');
      }, 360);
    }, interval);
  })();


  /* ---------------------------------------------------------------------
     USP labels — fit to one line by measurement, not by formula.

     A CSS size cannot be trusted here: iOS autosizes text per block, so a
     declared 15px can render at ~18px, and the copy is editable from the theme
     editor. Both break any vw formula fitted against declared sizes. This
     measures the actual laid-out text against the actual column and steps the
     shared size down until all three labels fit — so the result is right
     whatever the device does to the font, and whatever the copy says.
     --------------------------------------------------------------------- */
  (function () {
    var uspWrap = $('.r5__usps');
    if (!uspWrap) return;
    var rows = $$('.r5__usp', uspWrap);
    if (!rows.length) return;
    var MAX = 15, MIN = 9, STEP = 0.25;

    // The label is already clipped by text-overflow, and both scrollWidth and a
    // Range report the clipped width — so the natural width has to be measured on
    // an unclipped clone. It carries the same class inside the same row, so it
    // inherits the current --r5-usp-fs and the strong/regular mix.
    function naturalWidth(el) {
      var probe = el.cloneNode(true);
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;' +
        'white-space:nowrap;width:auto;max-width:none;flex:none;overflow:visible;';
      el.parentNode.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      probe.parentNode.removeChild(probe);
      return w;
    }
    function fits() {
      var avail = uspWrap.clientWidth;
      return rows.every(function (row) {
        var text = row.querySelector('.r5__usp-text');
        var icon = row.querySelector('.r5__usp-icon');
        if (!text) return true;
        var iconW = icon ? icon.getBoundingClientRect().width : 0;
        return naturalWidth(text) <= (avail - iconW - 1);   // 1px of rounding slack
      });
    }
    function fitUsps() {
      // A zero-width column means the block is not laid out yet (hidden tab,
      // pre-paint). Measuring then would fail every check and drive the size to
      // the floor, so wait for a real width instead.
      if (!uspWrap.clientWidth) return;
      var size = MAX;
      uspWrap.style.setProperty('--r5-usp-fs', size + 'px');
      while (size > MIN && !fits()) {
        size -= STEP;
        uspWrap.style.setProperty('--r5-usp-fs', size + 'px');
      }
    }
    // Fit now, then again after layout settles and after the webfont swaps in —
    // measuring against fallback metrics or a half-laid-out column reports a fit
    // that does not hold once the real font and width are in place.
    fitUsps();
    requestAnimationFrame(fitUsps);
    window.addEventListener('load', fitUsps);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitUsps);
    var uspTimer;
    function refit() {
      clearTimeout(uspTimer);
      uspTimer = setTimeout(fitUsps, 150);
    }
    window.addEventListener('resize', refit, { passive: true });
    // Catches what resize does not: rotation settling, the column changing width
    // from anything else on the page, and the first real layout if it lands late.
    if (window.ResizeObserver) new ResizeObserver(refit).observe(uspWrap);
  })();

  /* ---------------------------------------------------------------------
     Gallery — ported from reformly-july4-hero.js (rj4). Swiper track with
     loop, hover-side nav cursor, thumb strip, and a full rebuild when the
     colour changes (per-variant media_gallery metafield).
     --------------------------------------------------------------------- */
  // Default matches the rj4 hero (Purple/lavender first), not the capture's black
  var colour = 'lavender';
  var galleryEl = $('[data-r5-gallery]');
  var thumbBtns = $$('[data-r5-thumb]');
  var cursorEl = $('[data-r5-cursor]');
  var isMobile = function () { return window.innerWidth < 641; };

  var swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 380,
    loop: true,
    // Swiper 11 loop mode shifts slides around the active one. Reversing before a
    // transition finishes leaves the wrapper needing an instant re-translate —
    // one janky frame. A spare slide either side means the reversal target is
    // already in place and no loopFix has to run mid-gesture.
    loopAdditionalSlides: 1,
    // Swiper blocks sliding while a loop transition runs (loopPreventsSliding
    // defaults to true), so a reverse swipe mid-animation is swallowed and only
    // applied once the first transition ends — which is what reads as a dropped
    // frame. False lets the reversal take over immediately.
    loopPreventsSliding: false,
    grabCursor: false,
    // A few px of slack before a drag is claimed, and a wide touchAngle, so a
    // vertical flick scrolls the page instead of half-dragging the gallery.
    // longSwipesRatio lowers the distance needed to commit, so a short flick lands.
    threshold: 4,
    touchAngle: 40,
    longSwipesRatio: 0.25,
    resistanceRatio: 0.6,
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 24 },
      641: { slidesPerView: 1, spaceBetween: 24 }
    }
  };

  var swiper = null;
  var swiperReady = false;

  function updateThumbs(index) {
    thumbBtns.forEach(function (btn, i) { btn.classList.toggle('is-active', i === index); });
    if (swiperReady && thumbBtns[index]) {
      var thumb = thumbBtns[index];
      var container = thumb.parentElement;
      if (container) {
        container.scrollTo({
          left: thumb.offsetLeft - (container.offsetWidth / 2) + (thumb.offsetWidth / 2),
          // A smooth scroll here runs its own animation on top of the swipe and
          // competes with it; while the gallery is moving, jump instead.
          behavior: (swiper && swiper.animating) ? 'auto' : 'smooth'
        });
      }
    }
  }

  function bindThumbClicks() {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-r5-thumb'), 10);
        if (swiper) swiper.slideToLoop(idx);
      });
    });
  }

  // Only the on-screen active slide's video plays
  var galleryInView = true;
  function syncGalleryVideos() {
    if (!galleryEl) return;
    var active = (swiper && swiper.slides && swiper.slides[swiper.activeIndex]) ||
      galleryEl.querySelector('.swiper-slide-active');
    galleryEl.querySelectorAll('video').forEach(function (v) {
      if (galleryInView && active && active.contains(v)) {
        v.muted = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () { });
      } else {
        v.pause();
      }
    });
  }
  if (galleryEl && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      galleryInView = entries[0].isIntersecting;
      syncGalleryVideos();
    }, { threshold: 0.25 }).observe(galleryEl);
  }

  function initSwiper() {
    if (!galleryEl || typeof Swiper === 'undefined') return;
    swiper = new Swiper(galleryEl, swiperConfig);
    trackGallerySlide(swiper.realIndex);
    swiper.on('slideChange', function () {
      updateThumbs(swiper.realIndex);
      trackGallerySlide(swiper.realIndex);
    });
    // play()/pause() decode work stalls the compositor, so keep it off the
    // transition: settle first, then switch which video is running.
    swiper.on('slideChangeTransitionEnd', syncGalleryVideos);
    syncGalleryVideos();
    bindThumbClicks();
  }

  initSwiper();
  setTimeout(function () { swiperReady = true; }, 100);

  if (cursorEl && galleryEl) {
    var cursorSvg = cursorEl.querySelector('svg');
    galleryEl.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      cursorEl.classList.add('is-visible');
    });
    galleryEl.addEventListener('mouseleave', function () {
      cursorEl.classList.remove('is-visible');
    });
    galleryEl.addEventListener('mousemove', function (e) {
      if (isMobile()) return;
      if (e.target.closest('video')) { cursorEl.classList.remove('is-visible'); return; }
      cursorEl.classList.add('is-visible');
      var rect = galleryEl.getBoundingClientRect();
      var x = e.clientX - rect.left;
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
      cursorSvg.style.transform = x < rect.width / 2 ? 'scaleX(-1)' : '';
    });
    galleryEl.addEventListener('click', function (e) {
      if (isMobile()) return;
      if (e.target.closest('video')) return;
      if (!swiper) return;
      var rect = galleryEl.getBoundingClientRect();
      if (e.clientX - rect.left >= rect.width / 2) swiper.slideNext();
      else swiper.slidePrev();
    });
  }

  // Per-colour gallery data
  var galleryData = {};
  var galleryDataEl = section.querySelector('script[id^="r5-gallery-data-"]');
  if (galleryDataEl) {
    try { galleryData = JSON.parse(galleryDataEl.textContent); } catch (e) { }
  }

  function slideMediaHtml(item, i) {
    if (item.type === 'video' && item.sources && item.sources.length) {
      var sources = item.sources.map(function (s) {
        return '<source src="' + s.url + '" type="' + s.mime + '">';
      }).join('');
      // No autoplay / eager preload here either — syncGalleryVideos drives playback
      return '<video class="r5__gallery-img" controls playsinline muted loop preload="' + (i === 0 ? 'metadata' : 'none') + '"' +
        (item.poster ? ' poster="' + item.poster + '"' : '') + '>' + sources + '</video>';
    }
    return '<img src="' + item.src + '" alt="' + (item.alt || '') + '" class="r5__gallery-img" loading="' +
      (i === 0 ? 'eager' : 'lazy') + '">';
  }

  function rebuildGallery(colorKey) {
    var items = galleryData[colorKey];
    if (!items || !items.length || !galleryEl) return;

    // Destroy first so Swiper's loop clones are cleaned up
    if (swiper) { swiper.destroy(true, true); swiper = null; }

    var wrapper = galleryEl.querySelector('.swiper-wrapper');
    wrapper.innerHTML = items.map(function (item, i) {
      return '<div class="r5__gallery-item swiper-slide" data-media-index="' + i + '">' +
        slideMediaHtml(item, i) + '</div>';
    }).join('');

    swiper = new Swiper(galleryEl, swiperConfig);
    trackGallerySlide(swiper.realIndex);
    swiper.on('slideChange', function () {
      updateThumbs(swiper.realIndex);
      syncGalleryVideos();
      trackGallerySlide(swiper.realIndex);
    });
    requestAnimationFrame(syncGalleryVideos);

    var thumbsContainer = $('[data-r5-thumbs]');
    if (thumbsContainer) {
      thumbsContainer.innerHTML = items.map(function (item, i) {
        return '<button type="button" class="r5__thumb' + (i === 0 ? ' is-active' : '') +
          '" data-r5-thumb="' + i + '" aria-label="' + (item.alt || '') + '">' +
          '<div class="r5__thumb-img"><img src="' + item.thumb + '" alt="' + (item.alt || '') + '" loading="lazy"></div>' +
          '<span class="r5__thumb-bar"></span></button>';
      }).join('');
      thumbBtns = $$('[data-r5-thumb]');
      bindThumbClicks();
      thumbsContainer.scrollTo({ left: 0 });
      updateThumbs(0);
    }
  }

  $$('[data-r5-color]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('[data-r5-color]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      colour = btn.getAttribute('data-r5-color');
      var label = $('[data-r5-color-name]');
      if (label) label.textContent = btn.getAttribute('data-r5-color-label') || '';
      rebuildGallery(colour);
      syncSticky();
      ph('reformly_plus_color_select', { color: btn.getAttribute('data-r5-color-label') || colour });
    });
  });

  /* ---------------------------------------------------------------------
     Plan cards — selection drives the fused detail panel + sticky bar
     --------------------------------------------------------------------- */
  function selectedCard() { return $('.r5__plan-card.is-selected'); }

  function applyPlan(card) {
    $$('.r5__plan-card').forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = card.getAttribute('data-r5-plan');
    $$('[data-r5-detail]').forEach(function (d) {
      var on = d.getAttribute('data-r5-detail') === id;
      d.classList.toggle('r5__hidden', !on);
      d.style.display = on ? '' : 'none';
    });
    syncSticky();
  }

  $$('.r5__plan-card').forEach(function (card) {
    card.addEventListener('click', function () {
      if (card.classList.contains('is-selected')) return;
      applyPlan(card);
      ph('reformly_plus_plan_select', {
        plan: card.getAttribute('data-r5-plan'),
        price: card.getAttribute('data-r5-board-price')
      });
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); card.click(); }
    });
  });

  /* ---------------------------------------------------------------------
     Sticky bar
     --------------------------------------------------------------------- */
  var sticky = $('[data-r5-sticky]');

  function syncSticky() {
    var card = selectedCard();
    if (!card || !sticky) return;
    var title = $('[data-r5-sticky-title]');
    var price = $('[data-r5-sticky-price]');
    var compare = $('[data-r5-sticky-compare]');
    if (title) title.textContent = card.getAttribute('data-r5-sticky-name') || '';

    /* app-membership-002 sells the plan, so its cards carry their own price and
       the sticky shows $19.99 / $29.99 / /mo like app-membership-new. Detected
       from the attribute rather than the template: board cards do not have it,
       so they fall through to the board price exactly as before. */
    var planPrice = card.getAttribute('data-r5-plan-price');
    if (planPrice) {
      var unitEl = $('[data-r5-sticky-unit]');
      if (price) price.textContent = planPrice;
      if (compare) {
        var pc = card.getAttribute('data-r5-plan-compare') || '';
        compare.textContent = pc;
        compare.style.display = pc ? '' : 'none';
      }
      if (unitEl) unitEl.textContent = card.getAttribute('data-r5-plan-unit') || '';
      return;
    }

    if (price) price.textContent = card.getAttribute('data-r5-board-price') || '';
    // Capture sets boardCompareUnit to 0 for the one-time option (showCompare
    // false), so Board-only has no struck-through "was" price at all. Showing one
    // there implies a discount that option does not carry.
    // Anchor the sticky bar against total bundle value (board MSRP + the retail
    // value of the included gifts), which is what the capture's $266 represents —
    // not the board's own compare-at. Board-only carries no anchor at all.
    if (compare) {
      var cmp = card.getAttribute('data-r5-plan') === 'none'
        ? ''
        : (card.getAttribute('data-r5-bundle-compare')
          || card.getAttribute('data-r5-board-compare') || '');
      compare.textContent = cmp;
      compare.style.display = cmp ? '' : 'none';
    }
  }

  (function () {
    if (!sticky) return;
    var atc = $('.r5__atc');
    if (!atc) return;
    /* The board pages (005/006/007) keep the IntersectionObserver they shipped
       with — untouched, so nothing about their behaviour moves. */
    if (!section.classList.contains('r5--am002')) {
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting &&
            entries[0].boundingClientRect.bottom < 0);
        }, { threshold: 0, rootMargin: '0px 0px -100% 0px' }).observe(atc);
      } else {
        var onScrollLegacy = function () {
          sticky.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', onScrollLegacy, { passive: true });
        onScrollLegacy();
      }
      return;
    }

    /* app-membership-002 only, matching app-membership-new:

       - the position is read live on each frame rather than from
         entries[0].boundingClientRect, which is the rect recorded WHEN the
         crossing was observed. On a fast scroll that snapshot is stale and two
         crossings can coalesce, so the bar sometimes never appeared.
       - the threshold is the pinned header's height, not 0. .r5__logobar is
         position:sticky;top:0, so there is a ~50px band where the main button has
         slid behind it and is invisible while its rect.bottom is still positive.

       The rAF gate keeps this to one measurement per frame, and only while the
       page is moving. */
    var topbar = section.querySelector('.r5__logobar');
    var ticking = false;
    function place() {
      ticking = false;
      var topH = topbar ? topbar.getBoundingClientRect().height : 0;
      sticky.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < topH);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(place);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Layout can move the button without a scroll: rotation, font swap, an FAQ
    // opening above it, or the address bar collapsing on a phone.
    window.addEventListener('resize', onScroll, { passive: true });
    place();
  })();

  syncSticky();

  /* ---------------------------------------------------------------------
     FAQ accordion
     --------------------------------------------------------------------- */
  (function () {
    var items = $$('[data-r5-faq]');
    function closeItem(it) {
      if (!it.classList.contains('is-open')) return;
      var pn = it.querySelector('.r5__faq-panel');
      pn.style.height = pn.scrollHeight + 'px';
      requestAnimationFrame(function () { pn.style.height = '0'; });
      it.classList.remove('is-open');
      var b = it.querySelector('.r5__faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    function openItem(it) {
      var pn = it.querySelector('.r5__faq-panel');
      it.classList.add('is-open');
      // Measure once, then write on the next frame. The old version forced a
      // synchronous layout (offsetHeight) and then read scrollHeight again —
      // two layouts on the tap, before the animation had even started.
      var target = pn.scrollHeight;
      pn.style.height = '0px';
      requestAnimationFrame(function () { pn.style.height = target + 'px'; });
      var b = it.querySelector('.r5__faq-q');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (it) {
      var pn = it.querySelector('.r5__faq-panel');
      var btn = it.querySelector('.r5__faq-q');
      if (!pn || !btn) return;
      // settle on auto so a resize or font swap cannot clip the answer
      pn.addEventListener('transitionend', function () {
        if (it.classList.contains('is-open')) pn.style.height = 'auto';
      });
      btn.addEventListener('click', function () {
        var willOpen = !it.classList.contains('is-open');
        items.forEach(closeItem);            // single-open, same as the rj4 FAQ
        if (willOpen) openItem(it);
        /* Only opens are interesting — a collapse is the same person closing
           what they just read. willOpen is already computed here, so unlike the
           rj4 hero this needs no deferred class read. The question text is the
           label people recognise; an index would silently rewrite history the
           first time the FAQ is reordered. */
        if (willOpen) {
          var lbl = btn.querySelector('span') || btn;
          ph('reformly_plus_faq_click', { question: lbl.textContent.trim() });
        }
      });
    });
  })();

  /* ---------------------------------------------------------------------
     Cart drawer handoff — same contract the rj4 hero uses
     --------------------------------------------------------------------- */
  function openCartDrawer() {
    // The Plus drawer owns its own open/close (class .ryp-cart--open) and exposes
    // window.rypCart. Poking classes directly does nothing — it has to go through
    // the API so the cart refetches and the body scroll lock is applied.
    if (window.rypCart && window.rypCart.open) { window.rypCart.open(); return; }
    // Fallback: the theme's global ajax drawer, for any template without the Plus one.
    if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.cartRequestUpdate) {
      liquidAjaxCart.cartRequestUpdate();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (document.querySelector('[data-ajax-cart-section]')) {
      document.body.classList.add('js-ajax-cart-open');
    }
  }

  $$('[data-r5-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });

  /* ---------------------------------------------------------------------
     Add to cart
     --------------------------------------------------------------------- */
  var giftLines = {};
  (function () {
    var el = $('[data-r5-gift-lines]');
    if (!el) return;
    try { giftLines = JSON.parse(el.textContent); } catch (e) { giftLines = {}; }
  })();

  function setAdding(btn) {
    btn.classList.add('is-adding');
    if (!btn.getAttribute('data-r5-label')) btn.setAttribute('data-r5-label', btn.textContent);
    btn.textContent = 'ADDING…';
  }
  function setAdded(btn) {
    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    btn.textContent = 'ADDED';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = btn.getAttribute('data-r5-label') || 'ADD TO CART';
    }, 1600);
  }

  var atcButtons = $$('[data-r5-atc]');
  atcButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;

      var card = selectedCard();
      if (!card) return;
      var plan = card.getAttribute('data-r5-plan');
      var isOnetime = plan === 'none';
      var boardId = card.getAttribute('data-r5-board-' + colour);
      if (!boardId) {
        // Colour not stocked on this plan's board — fall back to any variant it has.
        boardId = card.getAttribute('data-r5-board-lavender') ||
          card.getAttribute('data-r5-board-black') ||
          card.getAttribute('data-r5-board-pink');
      }

      atcButtons.forEach(setAdding);

      var items = [];

      /* The perks are shown on the card as what the plan includes, but they are
         not sold as line items here: app-membership-002 goes straight to
         checkout, and four $0 rows next to the subscription only muddy it. The
         board pages keep adding them, which is where the gift variants are
         configured anyway. */
      var giftsInCart = !section.classList.contains('r5--am002');

      function addGift(key) {
        if (!giftsInCart) return;
        var vid = parseInt(giftLines[key], 10);
        if (vid) items.push({ id: vid, quantity: 1 });
      }

      /* The board is optional. app-membership-002 sells the plan on its own, so
         there is no board product configured and the cart is membership + perks.
         Socks are "free with every board order", so they follow the board. */
      if (boardId) {
        items.push({ id: parseInt(boardId, 10), quantity: 1 });
        addGift('socks');
      }

      if (!isOnetime) {
        var memId = card.getAttribute('data-r5-mem-variant');
        if (memId) {
          var memItem = { id: parseInt(memId, 10), quantity: 1 };
          var sp = card.getAttribute('data-r5-selling-plan');
          if (sp) memItem.selling_plan = parseInt(sp, 10);
          items.push(memItem);
        }
        // The four in-app perks come with a plan. They are real products so they
        // appear at checkout and their value localises.
        addGift('nutrition');
        addGift('classes');
        addGift('habit');
        addGift('community');
      } else {
        // Board on its own: the app entitlement is the Kickstart Challenge.
        addGift('kickstart');
      }

      // Nothing resolved (no board, no membership variant) — leave the cart alone
      if (!items.length) {
        atcButtons.forEach(function (b) {
          b.classList.remove('is-adding');
          b.textContent = b.getAttribute('data-r5-label') || 'ADD TO CART';
        });
        return;
      }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) { return res.json(); })
        /* Stamp the PostHog id onto the cart so the purchase can be attributed —
           the helper lives in layout/theme.liquid, which explains why cart
           attributes are the channel. Written after the add so /cart/clear.js
           can never race it, and awaited so it lands before a direct-checkout
           redirect navigates away. Referenced off window: if the helper is ever
           absent, .then(undefined) is a pass-through, where a bare identifier
           would throw and kill the add. */
        .then(window.rfStampCart)
        .then(function () {
          /* The sticky bar and the main CTA share data-r5-atc and this one
             handler, so without `source` they are indistinguishable in
             reporting. Read off the clicked button, not the DOM — atcButtons
             above has already restyled every one of them. */
          ph('reformly_plus_add_to_cart', {
            plan: plan,
            color: colour,
            source: btn.classList.contains('r5__sticky-btn') ? 'sticky' : 'main'
          });
          /* app-membership-002 sells a subscription with nothing to cross-sell,
             so it goes straight to checkout the way app-membership-new does.
             The board pages have no flag and keep opening the drawer. */
          if (section.getAttribute('data-r5-checkout') === 'direct') {
            window.location.href = '/checkout' + checkoutEmailParam();
            return;
          }
          atcButtons.forEach(setAdded);
          openCartDrawer();
        })
        .catch(function () {
          atcButtons.forEach(function (b) {
            b.classList.remove('is-adding');
            b.textContent = b.getAttribute('data-r5-label') || 'ADD TO CART';
          });
        });
    });
  });

  /* ---------------------------------------------------------------------
     Video carousel + modal — ported from reformly-july4-hero.js.
     Desktop tap opens the modal; phone plays inline (native fullscreen on iOS).
     --------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------
     Video rail — native overflow scrolling, not Swiper.

     freeMode reimplements momentum in JS: every frame of a flick is a script
     callback writing a transform, which is what stutters on a phone. Handing the
     rail to the scroller puts momentum, rubber-band and deceleration in the
     compositor, where iOS runs them off the main thread — and it deletes the
     scroll-physics config entirely. The only JS left is a passive listener that
     sizes the progress bar, throttled to one write per frame.
     --------------------------------------------------------------------- */
  var videoCarouselEl = $('[data-r5-video-swiper]');
  if (videoCarouselEl) {
    var railTrack = videoCarouselEl.querySelector('.swiper-wrapper');
    var railBar = videoCarouselEl.parentElement &&
      videoCarouselEl.parentElement.querySelector('.swiper-scrollbar') ||
      videoCarouselEl.querySelector('.swiper-scrollbar');
    var railDrag = null;
    if (railBar) {
      railDrag = railBar.querySelector('.swiper-scrollbar-drag');
      if (!railDrag) {
        railDrag = document.createElement('div');
        railDrag.className = 'swiper-scrollbar-drag';
        railBar.appendChild(railDrag);
      }
    }
    var railTick = false;
    function paintRailBar() {
      railTick = false;
      if (!railDrag || !railTrack) return;
      var visible = videoCarouselEl.clientWidth;
      var total = videoCarouselEl.scrollWidth;
      if (total <= visible) { railDrag.style.width = '0'; return; }
      var ratio = visible / total;
      railDrag.style.width = (ratio * 100) + '%';
      railDrag.style.transform = 'translateX(' +
        (videoCarouselEl.scrollLeft / total * videoCarouselEl.clientWidth) + 'px)';
    }
    videoCarouselEl.addEventListener('scroll', function () {
      if (railTick) return;
      railTick = true;
      requestAnimationFrame(paintRailBar);
    }, { passive: true });
    window.addEventListener('resize', paintRailBar, { passive: true });
    paintRailBar();
  }

  var vmodal = $('[data-r5-vmodal]');
  var vmodalSwiperEl = $('[data-r5-vmodal-swiper]');
  var vmodalSwiper = null;
  var isMobileDevice = function () { return window.innerWidth < 768; };
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  function stopAllModalVideos() {
    if (!vmodal) return;
    vmodal.querySelectorAll('video').forEach(function (v) {
      v.pause();
      v.currentTime = 0;
      v.muted = true;
    });
    vmodal.querySelectorAll('.r5__vmodal-slide').forEach(function (s) { s.classList.remove('is-unmuted'); });
  }

  function playModalSlide(idx) {
    if (!vmodalSwiper) return;
    vmodal.querySelectorAll('.r5__vmodal-slide').forEach(function (s, i) {
      var v = s.querySelector('video');
      if (!v) return;
      if (i === idx) { v.play(); } else { v.pause(); v.currentTime = 0; }
    });
  }

  function openVModal(slideIdx) {
    if (!vmodal || !vmodalSwiperEl) return;
    vmodal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (!vmodalSwiper) {
      vmodalSwiper = new Swiper(vmodalSwiperEl, { slidesPerView: 1, spaceBetween: 20, speed: 300 });
      vmodalSwiper.on('slideChange', function () {
        var idx = vmodalSwiper.activeIndex;
        playModalSlide(idx);
        var slides = vmodal.querySelectorAll('.r5__vmodal-slide');
        slides.forEach(function (s) { s.classList.remove('is-unmuted'); });
        var active = slides[idx];
        if (active) {
          var v = active.querySelector('video');
          if (v) { v.muted = false; active.classList.add('is-unmuted'); }
        }
      });

      var prevBtn = vmodal.querySelector('[data-r5-vmodal-prev]');
      var nextBtn = vmodal.querySelector('[data-r5-vmodal-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { vmodalSwiper.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { vmodalSwiper.slideNext(); });

      vmodal.querySelectorAll('[data-r5-vmodal-mute]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = btn.closest('.r5__vmodal-slide');
          var video = slide.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          slide.classList.toggle('is-unmuted', !video.muted);
        });
      });
    }

    vmodalSwiper.slideTo(slideIdx, 0);
    setTimeout(function () {
      playModalSlide(slideIdx);
      var activeSlide = vmodal.querySelectorAll('.r5__vmodal-slide')[slideIdx];
      if (activeSlide) {
        var v = activeSlide.querySelector('video');
        if (v) { v.muted = false; activeSlide.classList.add('is-unmuted'); }
      }
    }, 100);
  }

  function closeVModal() {
    if (!vmodal) return;
    stopAllModalVideos();
    vmodal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (vmodal) {
    var closeBtn = vmodal.querySelector('[data-r5-vmodal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeVModal);
    vmodal.addEventListener('click', function (e) { if (e.target === vmodal) closeVModal(); });
  }

  if (videoCarouselEl) {
    videoCarouselEl.querySelectorAll('.r5__video-slide').forEach(function (slide, idx) {
      var playBtn = slide.querySelector('.r5__video-play');
      var video = slide.querySelector('video');
      if (!playBtn || !video) return;

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!isMobileDevice()) { openVModal(idx); return; }

        slide.classList.add('is-playing');
        if (isIOS) {
          video.play();
          if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
          else if (video.requestFullscreen) video.requestFullscreen();
        } else {
          video.setAttribute('controls', '');
          video.play();
        }

        if (video.readyState < 3) {
          slide.classList.add('is-loading');
          video.addEventListener('canplay', function handler() {
            slide.classList.remove('is-loading');
            video.removeEventListener('canplay', handler);
          });
        }
      });

      video.addEventListener('ended', function () {
        slide.classList.remove('is-playing');
        video.removeAttribute('controls');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Nav cart count is driven by reformly-plus-cart.js, which writes to
     [data-rj4-cart-count] after every /cart.js call and once on load. The old
     liquid-ajax-cart listeners here never fired — the Plus drawer does not use
     that library — so the badge only ever showed its server-rendered value.
     --------------------------------------------------------------------- */

})();
